const ShoppingBasketPlus = () => (

    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        stroke="#832865"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M11 9 L18 9" />
        <path d="M11.5 19.5 L12.5 28.5" />
        <path d="M14.5 6 L14.5 12" />
        <path d="M17.5 19.5 L16.5 28.5" />
        <path d="M19.4 28.5 A2 2 0 0 0 21.4 26.9" />
        <path d="M21.4 26.9 L23.1 19.5" />
        <path d="M21.5 19.5 L17.5 12.5" />
        <path d="M22.066 24 L6.973 24" />
        <path d="M4.5 19.5 L24.5 19.5" />
        <path d="M6 19.5 L7.6 26.9" />
        <path d="M7.5 19.5 L11.5 12.5" />
        <path d="M7.6 26.9 A2 2 0 0 0 9.6 28.5" />
        <path d="M9.6 28.5 L19.4 28.5" />
    </svg>
);

export default ShoppingBasketPlus;
